import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Lynette Miles --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Common Observability Platform tasks";
const frontMatter = {
  "title": "Common Observability Platform tasks",
  "description": "Learn about common workflows in Chronosphere Observability Platform."
};
export function useTOC(props) {
  return [{
    value: "Reduce high cardinality",
    id: "reduce-high-cardinality",
    depth: 2
  }, {
    value: "Explore services and telemetry data",
    id: "explore-services-and-telemetry-data",
    depth: 2
  }, {
    value: "Use traces to find problems",
    id: "use-traces-to-find-problems",
    depth: 2
  }, {
    value: "Best practices when using dashboard intervals",
    id: "best-practices-when-using-dashboard-intervals",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    h1: "h1",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Common Observability Platform tasks"}</_components.h1>{"\n"}<_components.p>{"The following guides help you use Chronosphere Observability Platform features to\nperform a given task."}</_components.p>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"When your metric cardinality is high, you can\n"}<_components.a href="/control/shaping/reduce-cardinality">{"use this guide"}</_components.a>{" to learn how to reduce it."}</_components.p>{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<_components.p>{"Use "}<_components.a href="/observe/services/service-exploration">{"Service pages"}</_components.a>{" to explore issues with a\nservice and connected services, and leverage other telemetry data to help find and\nresolve problems."}</_components.p>{"\n"}<_components.h2 id={toc[2].id}>{toc[2].value}</_components.h2>{"\n"}<_components.p>{"Learn how to use tracing data during\n"}<_components.a href="/investigate/querying/traces/examples">{"on-call triage"}</_components.a>{" to find the source of a\nproblem."}</_components.p>{"\n"}<_components.h2 id={toc[3].id}>{toc[3].value}</_components.h2>{"\n"}<_components.p>{"Learn about dashboard "}<_components.a href="/observe/dashboards/customization/intervals">{"query intervals and data resolution"}</_components.a>{"."}</_components.p></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/overview/common-tasks',
  {"filePath":"pages/overview/common-tasks.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)